import { getApps, initializeApp, type FirebaseApp } from "firebase/app";

import { initFirebaseAppCheck } from "./app-check";
import { getFirebasePublicConfig } from "./config";

export function getFirebaseApp(): FirebaseApp {
  const config = getFirebasePublicConfig();

  const existing = getApps()[0];
  if (existing) {
    initFirebaseAppCheck(existing);
    return existing;
  }

  const app = initializeApp(config);
  initFirebaseAppCheck(app);
  return app;
}
